/*

npm i -g npm-check-updates
ncu -u
npm install

*/

const protocol = window.location.protocol;
const hostname = window.location.hostname;
const port = window.location.port;

let a, s, af, sf, pusher_app_key;

af = "https://api-timbrado.acrescoweb.com/public/api/";
sf = "https://api-timbrado.acrescoweb.com/public/";
console.log(protocol, hostname, port);
switch (hostname) {
	case 'localhost':
	case '127.0.0.1':
		a = 'https://api_integraciones.test/api/';
		s = 'https://api_integraciones.test/';
		pusher_app_key = '80a4bafad209749734c6';
		break;
	case '192.168.1.147':
		a = 'http://192.168.1.147/api_integraciones/public/api/';
		s = 'http://192.168.1.147/api_integraciones/public/';
		pusher_app_key = '80a4bafad209749734c6';
		break;
	case '192.168.1.76':
		a = 'http://192.168.1.76/api_integraciones/public/api/';
		s = 'http://192.168.1.76/api_integraciones/public/';
		pusher_app_key = '80a4bafad209749734c6';
		break;
	case 'integraciones.conexopen.com':
		a = 'http://integraciones.conexopen.com/api_integraciones/public/api/';
		s = 'http://integraciones.conexopen.com/api_integraciones/public/';
		pusher_app_key = '80a4bafad209749734c6';
		break;
		
	case 'imac-acresco.d1wet0kv5qebe5.amplifyapp.com':
		a = 'http://100.26.217.213/api/';
		s = 'http://100.26.217.213/';
		pusher_app_key = '6de7ef05c9261dbb1404';
		break;
	default:
		a = protocol + '//api-' + hostname + '/public/api/';
		s = protocol + '//api-' + hostname + '/public/';
		//af = "https://localhost/api_cfdi/public/api/";
		//sf = "https://localhost/api_cfdi/public/";
		pusher_app_key = '6de7ef05c9261dbb1404';
}

const api = a;
const src = s;
const api_rocket_chat = "http://31.220.54.59:3000/api/v1/";
const api_facturacion = af;
const src_facturacion = sf;

const basename = hostname === 'localhost' ? (Number(port) === 3000 || Number(port) === 3001 || Number(port) === 3002 || Number(port) === 3003 ? '' : '/acresco/build/') : '/';

export const CONFIG = {
	prefix: 'acresco',
	id_project: 2,
	api_facturacion: api_facturacion,
	src_facturacion: src_facturacion,
	api: api,
	api_rocket_chat: api_rocket_chat,
	src: src,
	basename: basename,
	foto_default: src + 'file/perfil/default-perfil.svg',
	logo_default: src + 'file/logo/default-logo.svg',
	portada_default: src + 'file/portada/default-portada.svg',
	menu: 1,
	debug: true,
	pusher_app_key: pusher_app_key,
	pusher_app_cluster: 'us2',
	pusher_app_force_tls: true,
	pusher_app_log_to_console: true,
	segundo_confirmar_token_expirado: 30,
	tipo_menu_contextual: 2,
	onesignal_hostname_prod: 'integraciones.mlp.mx',
	onesignal_app_id_prod: '6b907ea6-0d3a-4d23-8cb5-6b2c5b94ba8e',
	onesignal_app_id_test: '5e077659-5d4d-4420-9e62-f4a96330c4d6',
	titulo_alert_confirm: 'Acresco soluciones',
	
	DROPBOX_TOKEN: "Zto1IdH0HsAAAAAAAAAAEf3ZBqVsxJoNqmcp2-zRmCl6GkG7RpIDpAwShiiEY5je",
	DROPBOX_API: "https://api.dropboxapi.com/2/files/",
	DROPBOX_CONTENT: "https://content.dropboxapi.com/2/files/",
};
